export const appId = "jazasoft";